<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>

                <li @click="setComponenteAtivo('SimsInspetorTabPage','SERVIÇOS DE INSPEÇÃO')">
                    <img src="@/assets/icons/menuSims.png" alt="Serviços de Inspeção" />
                    <span>Serviços de Inspeção</span>
                </li>

                <li @click="setComponenteAtivo('EstabelecimentosInspetorTabPage', 'ESTABELECIMENTOS')">
                    <img src="@/assets/icons/menuEstabelecimentos.png" alt="Estabelecimentos" />
                    <span>Estabelecimentos</span>
                </li>

                <li @click="setComponenteAtivo('ListaAtividadesPage', 'HISTÓRICO DE ATIVIDADES')">
                    <img src="@/assets/icons/menuHistory.png" />
                    <span>Histórico de Atividades</span>
                </li>

                <li @click="setComponenteAtivo('Pla08TabPage', 'AÇÕES CORRETIVAS')">
                    <img src="@/assets/icons/menuRAC.png" />
                    <span>Ações Corretivas (RAC)</span>
                </li>

                <li @mouseover="showPlanilhasMenu = true" @mouseleave="showPlanilhasMenu = false">
                    <img src="@/assets/icons/menuTable.svg" />
                    <span>Planilhas</span>
                    <div v-if="showPlanilhasMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('PlaExpedicaoTabPage', 'PLANILHAS DE EXPEDIÇÃO')">
                                <span>Expedição</span>
                            </li>
                            <li @click="selectOption('PlaLeiteTabPage', 'PLANILHAS DE LEITE')">
                                <span>Leite</span>
                            </li>
                            <li @click="selectOption('PlaMelTabPage', 'PLANILHAS DE MEL')">
                                <span>Mel</span>
                            </li>
                            <li @click="selectOption('PlaMpTabPage', 'PLANILHAS DE MATÉRIA PRIMA')">
                                <span>Matéria Prima</span>
                            </li>
                            <li @click="selectOption('PlaProducaoTabPage', 'PLANILHAS DE PRODUÇÃO')">
                                <span>Produção</span>
                            </li>

                            
                            <li @click="selectOption('DocAnulacaoEstabelecimentosTabPage', 'ESTORNO DE PLANILHAS HOMOLOGADAS')">
                                <span>Estorno de Planilhas Homologadas</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showAcoesMenu = true" @mouseleave="showAcoesMenu = false">
                    <img src="@/assets/icons/menuOffice.svg" />
                    <span>Aprovações e Homologações</span>
                    <div v-if="showAcoesMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="setComponenteAtivo('AnexosInspetorListaPage', 'DOCUMENTAÇÕES DE ESTABELECIMENTOS')">
                            <img src="@/assets/icons/menuDocumentos.png" />
                            <span>Documentação Estabelecimento</span>
                        </li></ul>

                        <ul><li @click="setComponenteAtivo('Pla08DeferimentoTabPage', 'RAC PENDENTES DE HOMOLOGAÇÃO')">
                            <img src="@/assets/icons/menuRAC.png" />
                            <span>RAC Pendentes</span>
                        </li></ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('RotulosInspetorListaPage', 'RÓTULOS')">
                    <img src="@/assets/icons/menuRotulos.png" />
                    <span>Rótulos</span>
                </li>

                <li @click="setComponenteAtivo('UsuariosRtTabPage', 'RESPONSÁVEIS TÉCNICOS')">
                    <img src="@/assets/icons/menuRt.png" alt="RT's" />
                    <span>Responsáveis Técnicos</span>
                </li>
                
                <li @click="setComponenteAtivo('DriveInternoListaPage', 'DRIVE')">
                    <img src="@/assets/icons/drive.svg" />
                    <span>Drive</span>
                </li>
                
                <li @click="setComponenteAtivo('MapaEnderecosPage', 'MAPA')">
                    <img src="@/assets/icons/menuMap.svg" />
                    <span>Mapa Endereços</span>
                </li>

                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.png" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('ColetaNCAnaliticoReportPage', 'RELATÓRIO: NÃO CONFORMIDADES DE COLETAS')">
                            <span>Coletas - Não Conformidades</span>
                        </li></ul>
                        
                        <ul><li @click="selectOption('EstebelecimentosParecerReportPage', 'RELATÓRIO: PARECER ESTABELECIMENTOS')">
                            <span>Estabelecimentos - Parecer Analítico</span>
                        </li></ul>

                        <ul><li @click="selectOption('NCAnaliticoReportPage', 'RELATÓRIO: ANALÍTICO DE NÃO CONFORMIDADES')">
                            <span>Não Conformidades - Analítico</span>
                        </li></ul>
                    </div>
                </li>
                
                <li @click="setComponenteAtivo('UsuarioViewPage', 'USUÁRIO')">
                    <img src="@/assets/icons/menuEditUser.png" />
                    <span>Usuário</span>
                </li>

                <li class="logout" @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.png" alt="Desconectar" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>


        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'INSPETOR' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ globalStore.nmusuario }}</div>
                        <div class="establishment-name">{{ globalStore.nmsim ? globalStore.nmsim : 'Aguardando sim...' }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='DriveInternoListaPage'"><DriveInternoListaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosInspetorTabPage'"><EstabelecimentosInspetorTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ListaAtividadesPage'"><ListaAtividadesPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MapaEnderecosPage'"><MapaEnderecosPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla08TabPage'"><Pla08TabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RotulosInspetorListaPage'"><RotulosInspetorListaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='SimsInspetorTabPage'"><SimsInspetorTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosRtTabPage'"><UsuariosRtTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=globalStore.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='AnexosInspetorListaPage'"><AnexosInspetorListaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla08DeferimentoTabPage'"><Pla08DeferimentoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='ColetaNCAnaliticoReportPage'"><ColetaNCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstebelecimentosParecerReportPage'"><EstebelecimentosParecerReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NCAnaliticoReportPage'"><NCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='DocAnulacaoEstabelecimentosTabPage'"><DocAnulacaoEstabelecimentosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaExpedicaoTabPage'"><PlaExpedicaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaLeiteTabPage'"><PlaLeiteTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMelTabPage'"><PlaMelTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMpTabPage'"><PlaMpTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaProducaoTabPage'"><PlaProducaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else><ResumoGeralPage /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';
import { useRouter } from 'vue-router';
import DriveInternoListaPage from '@/views/utils/drive/DriveInternoListaPage.vue';
import EstabelecimentosInspetorTabPage from '@/views/cadastros/tabelas/EstabelecimentosInspetorTabPage.vue';
import ListaAtividadesPage from '@/views/planilhas/tabelas/ListaAtividadesPage.vue';
import MapaEnderecosPage from '@/views/dashboard/MapaEnderecosPage.vue';
import Pla08TabPage from '../../views/planilhas/tabelas/Pla08TabPage.vue';
import ResumoGeralPage from '@/components/dashboards/ResumoGeralPage.vue';
import RotulosInspetorListaPage from '../operacoes/RotulosInspetorListaPage.vue';
import SimsInspetorTabPage from '@/views/cadastros/tabelas/SimsInspetorTabPage.vue';
import UsuariosRtTabPage from '@/views/cadastros/tabelas/UsuariosRtTabPage.vue';
import UsuarioViewPage from '@/views/cadastros/visualizacoes/UsuarioViewPage.vue';

// SUBMENU ANÁLISES E HOMOLOGAÇÕES
import AnexosInspetorListaPage from '../listas/AnexosInspetorListaPage.vue';
import Pla08DeferimentoTabPage from '@/views/planilhas/tabelas/Pla08DeferimentoTabPage.vue';

// SUBMENU PLANILHAS
import DocAnulacaoEstabelecimentosTabPage from '@/views/docs/tabelas/DocAnulacaoEstabelecimentosTabPage.vue';
import PlaExpedicaoTabPage from '@/views/planilhas/tabelas/PlaExpedicaoTabPage.vue';
import PlaLeiteTabPage from '@/views/planilhas/tabelas/PlaLeiteTabPage.vue';
import PlaMelTabPage from '@/views/planilhas/tabelas/PlaMelTabPage.vue';
import PlaMpTabPage from '@/views/planilhas/tabelas/PlaMpTabPage.vue';
import PlaProducaoTabPage from '@/views/planilhas/tabelas/PlaProducaoTabPage.vue';

// SUBMENU RELATÓRIOS
import ColetaNCAnaliticoReportPage from '../reports/ColetaNCAnaliticoReportPage.vue';
import EstebelecimentosParecerReportPage from '../reports/EstebelecimentosParecerReportPage.vue';
import NCAnaliticoReportPage from '../reports/NCAnaliticoReportPage.vue';

const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showAcoesMenu = ref(false);
const showPlanilhasMenu = ref(false);
const showRelatoriosMenu = ref(false);
const timeRemaining = ref(null);
let timer = null;
const menuIcon = computed(() =>
    isCollapsed.value
        ? require('@/assets/icons/menuExpand.svg')
        : require('@/assets/icons/menuCollapse.svg')
);

const confirmLogout = () => {
    resetLogin();
}

const resetLogin = () => {
    Api.loginAPI();
    router.push('/login');
}

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value = page;
    nmTitulo.value = titulo;
    showAcoesMenu.value = false;
    showPlanilhasMenu.value = false;
    showRelatoriosMenu.value = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const toggleMenu = () => {isCollapsed.value = !isCollapsed.value;}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>